import { gql } from "@apollo/client";

export const DOWNLOAD_REQUIRED_DOCUMENT_TEMPLATE_QUERY = gql`
  query downloadRequiredDocumentTemplate($quoteId: Int!, $requiredDocTypeId: Int!, $requiredDocContentType: String!) {
    downloadRequiredDocumentTemplate(
      quoteId: $quoteId
      requiredDocTypeId: $requiredDocTypeId
      requiredDocContentType: $requiredDocContentType
    ) {
      name
      content
    }
  }
`;

export const DOWNLOAD_DMS_FILE_QUERY = gql`
  query downloadDmsFile(
    $quoteId: Int!
    $sharePointUID: String!
    $fileName: String!
    $quoteStep: Int!
    $guarantorId: Int
  ) {
    downloadDmsFile(
      quoteId: $quoteId
      sharePointUID: $sharePointUID
      fileName: $fileName
      quoteStep: $quoteStep
      guarantorId: $guarantorId
    ) {
      name
      content
    }
  }
`;

export const QUOTE_QUERY = gql`
  query quote($quoteId: Int!, $loadScoringQuestions: Boolean!) {
    quote(quoteId: $quoteId) {
      quoteId
      quoteStatusId
      quoteStatusCode
      quoteStatusName
      scoringQuestions @skip(if: $loadScoringQuestions) {
        quoteId
        questionId
        questionCode
        questionText
        questionDescription
        isMandatory
        variableTypeId
        variableTypeCode
        variableTypeName
        questionAnswer
        optionIsRange
        optionId
        options {
          optionValueId
          optionValueCode
          optionValueName
          optionId
          fromValue
          toValue
          orderNo
        }
      }
      requiredDocuments {
        quoteId
        id
        requiredDocTypeId
        requiredDocFileName
        requiredDocName
        requiredDocContentType
        targetAreaCode
        caption
        isVisible
        isMandatory
        guarantorId
        files {
          sharePointUID
          fileName
        }
      }
    }
  }
`;

export const ALLOWED_FILE_EXTENSION_UPLOADS = gql`
  query allowedFileExtensionUploads {
    allowedFileExtensionUploads
  }
`;

export const PRODUCT_DOCUMENT = gql`
  query productDocument($quoteId: Int!) {
    productDocument(quoteId: $quoteId) {
      quoteId
      quoteProductId
      caption
    }
  }
`;

export const CHECK_TEG = gql`
  query checkTeg($quoteId: Int!) {
    checkTeg(quoteId: $quoteId)
  }
`;
